import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import CopyToClipboard from "react-copy-to-clipboard";
import { useDispatch, useSelector } from 'react-redux';
import { virtualAccountViewStart } from '../../store/actions/WalletAction';
import NoDataFound from '../helper/NoDataFound';
import { getSuccessNotificationMessage } from '../helper/ToastNotification';
import Skeleton from 'react-loading-skeleton';
import iso from "iso-3166-1";
import { profileStart } from '../../store/actions/UserAction';

const AccountDetailsModal = (props) => {
  const dispatch = useDispatch()
  const virtualAccountView = useSelector((state) => state.wallet.virtualAccountView);
  const profile = useSelector((state) => state.user.profile);

  useEffect(() => {

    dispatch(virtualAccountViewStart())
  }, [])

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="account-details-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {profile.data?.fr_status !== "ACTIVE" ?
            <div className="no_data_content item_center_column  text-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="300"
                height="83"
                fill="none"
                viewBox="0 0 101 83"
              >
                <path
                  fill="#F9C201"
                  d="M47.58 57.714a30.7 30.7 0 0 1-8.991 3.764A31 31 0 0 1 14.788 57.7 31.12 31.12 0 0 1 .896 38.593C-3.184 21.853 7.055 4.978 23.794.9c16.725-4.092 33.6 6.159 37.693 22.898 3.284 13.468-2.724 27.018-13.906 33.916"
                ></path>
                <path
                  fill="#fff"
                  d="M40.672 27.626a9.49 9.49 0 1 1-18.976 0 9.49 9.49 0 0 1 18.976 0"
                ></path>
                <path
                  fill="#fff"
                  d="M47.58 53.8v3.914a30.7 30.7 0 0 1-8.991 3.764A31 31 0 0 1 14.788 57.7v-3.901c0-9.033 7.336-16.397 16.397-16.397S47.58 44.766 47.58 53.8"
                ></path>
                <path
                  fill="#C7C7C7"
                  d="m95.5 68 2.657-4.778-25.524-14.417-2.657 4.778z"
                ></path>
                <path
                  fill="#263238"
                  d="m95.972 69.828 4.554-7.51L81.055 51.49 76.5 59z"
                ></path>
                <path
                  fill="#37474F"
                  d="M53.192 65.848c-14.274 1.947-27.47-8.082-29.417-22.355s8.081-27.47 22.355-29.417 27.47 8.08 29.417 22.355c1.947 14.274-8.082 27.47-22.355 29.417m-.405-2.967c12.637-1.725 21.516-13.407 19.793-26.045-1.724-12.638-13.407-21.516-26.045-19.793-12.638 1.724-21.516 13.407-19.792 26.044 1.722 12.639 13.406 21.518 26.044 19.794"
                ></path>
                <path
                  fill="#37474F"
                  d="M72.299 25.412a26.75 26.75 0 0 1 4.018 10.913c.97 7.11-.894 14.18-5.246 19.907-4.353 5.729-10.665 9.417-17.775 10.386-7.109.97-14.179-.894-19.906-5.246-5.728-4.353-9.417-10.665-10.385-17.775C21 28.9 31.327 15.31 46.025 13.305c7.11-.97 14.18.893 19.907 5.246a27 27 0 0 1 6.367 6.861M28.33 53.67a25.4 25.4 0 0 0 6 6.465c5.398 4.102 12.059 5.857 18.756 4.943 6.697-.913 12.644-4.39 16.746-9.786 4.102-5.397 5.857-12.058 4.943-18.756a25.2 25.2 0 0 0-3.792-10.277c-5.172-8.023-14.684-12.785-24.75-11.413-13.848 1.89-23.578 14.693-21.69 28.542A25.2 25.2 0 0 0 28.33 53.67m41.448-26.637a23.8 23.8 0 0 1 3.571 9.7c1.782 13.062-7.395 25.138-20.457 26.92-6.318.862-12.6-.794-17.691-4.663-5.09-3.868-8.368-9.478-9.23-15.795-.861-6.318.794-12.601 4.663-17.691 3.868-5.09 9.477-8.368 15.795-9.23 6.319-.862 12.601.794 17.691 4.662a24 24 0 0 1 5.658 6.097M52.681 62.11c12.212-1.666 20.793-12.957 19.127-25.169-.806-5.906-3.87-11.15-8.63-14.767s-10.634-5.165-16.54-4.36c-5.906.806-11.15 3.87-14.767 8.63s-5.165 10.634-4.36 16.54c.806 5.907 3.871 11.151 8.63 14.768 4.76 3.616 10.635 5.164 16.54 4.358"
                ></path>
                <g opacity="0.2">
                  <foreignObject width="84.465" height="84.469" x="7.853" y="-2.108">
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      clipPath="url(#bgblur_0_3101_7390_clip_path)"
                      style={{
                        backdropFilter: "blur(10px)",
                        height: "100%",
                        width: "100%",
                      }}
                    ></div>
                  </foreignObject>
                  <path
                    fill="#fff"
                    d="M28.711 46.225c3.367 11.803 15.665 18.645 27.471 15.277 11.802-3.366 18.644-15.669 15.277-27.471-3.367-11.806-15.67-18.648-27.472-15.282-11.807 3.37-18.644 15.67-15.276 27.476"
                    data-figma-bg-blur-radius="20"
                  ></path>
                  <path
                    fill="#EBEBEB"
                    d="M30.849 51.806c5.122 8.152 15.184 12.31 24.912 9.53a22.2 22.2 0 0 0 5.578-2.454zM30.114 29.383l41.759 9.693a22.2 22.2 0 0 0-.837-5.212 21.9 21.9 0 0 0-2.432-5.532l-30.831-7.16a22.2 22.2 0 0 0-7.659 8.211M27.79 43.899l39.777 9.232a22.6 22.6 0 0 0 2.227-3.75l-42.357-9.832c-.032 1.436.085 2.89.353 4.35M28.856 32.153l42.93 9.968q.041-.404.067-.804l-42.7-9.911c-.107.243-.21.492-.297.747M44.646 18.306l19.055 4.423a22 22 0 0 0-1.605-1.19L46.6 17.942q-.977.133-1.954.364"
                  ></path>
                </g>
                <path
                  fill="#fff"
                  d="M51.085 57.852c-2.404.302-4.88-.002-7.236-.695-1.185-.34-2.326-.832-3.428-1.402a19.5 19.5 0 0 1-3.094-2.075 17.6 17.6 0 0 1-4.531-5.85 19.3 19.3 0 0 1-1.842-7.037c.79 2.282 1.715 4.464 2.91 6.46.625.978 1.252 1.953 2.023 2.81.744.875 1.54 1.707 2.437 2.424 1.753 1.48 3.77 2.643 5.925 3.528a29.8 29.8 0 0 0 6.836 1.837"
                ></path>
                <defs>
                  <clipPath
                    id="bgblur_0_3101_7390_clip_path"
                    transform="translate(-7.853 2.108)"
                  >
                    <path d="M28.711 46.225c3.367 11.803 15.665 18.645 27.471 15.277 11.802-3.366 18.644-15.669 15.277-27.471-3.367-11.806-15.67-18.648-27.472-15.282-11.807 3.37-18.644 15.67-15.276 27.476"></path>
                  </clipPath>
                </defs>
              </svg>
              <div className="no-bot-exists-info">
                <h4>Account under evaluation</h4>
              </div>
              <Button className="action-btn primary " onClick={() => dispatch(profileStart())}>
                Retry
              </Button>
            </div>
            :
            <>
              {(virtualAccountView.loading||profile.loading) ?
                <div className="account-details-content">
                  <Skeleton height={450} />
                </div>
                :
                <>
                  <div className="account-details-titles">
                    <h2>Account Details</h2>
                  </div>
                  {Object.keys(virtualAccountView.data).length > 0 ?
                    <div className="account-details-content">
                      <div className="account-details-top">
                        <p>Created at  <span> {virtualAccountView.data.virtual_account.created_at_formatted} </span></p>
                        <div className="account-details-name">
                          <p>Account Holder Name  <span> {virtualAccountView.data.virtual_account.account_holder_name} </span></p>
                          <div className="account-crypto-badge">
                            {virtualAccountView.data.virtual_account?.currency || "N/A"}
                          </div>
                        </div>
                        <div className="account-number mt-4">
                          <p>IBAN  <span> {virtualAccountView.data.virtual_account.account_number} </span></p>

                        </div>
                      </div>
                      <div className="account-details-middle">
                        <div className="account-info-card">
                          <div className="info-label-card">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlSpace="preserve"
                              width="24"
                              height="24"
                              viewBox="0 0 330 330"
                            >
                              <path
                                fill="#878e96"
                                d="M97.5 165c0-8.284-6.716-15-15-15h-60c-8.284 0-15 6.716-15 15s6.716 15 15 15h60c8.284 0 15-6.716 15-15m210-15h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15m-135-60c8.284 0 15-6.716 15-15V15c0-8.284-6.716-15-15-15s-15 6.716-15 15v60c0 8.284 6.716 15 15 15m.001 150c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15s15-6.716 15-15v-60c0-8.284-6.716-15-15-15M77.04 48.327c-5.856-5.858-15.354-5.857-21.213 0-5.858 5.858-5.858 15.355 0 21.213l42.427 42.428a14.95 14.95 0 0 0 10.606 4.394c3.838 0 7.678-1.465 10.606-4.393 5.858-5.858 5.858-15.355 0-21.213zm169.706 169.707c-5.857-5.857-15.355-5.857-21.213 0s-5.857 15.355 0 21.213l42.428 42.426a14.95 14.95 0 0 0 10.607 4.393c3.839 0 7.678-1.465 10.606-4.393 5.858-5.858 5.858-15.355 0-21.213zm-148.492 0L55.828 260.46c-5.858 5.858-5.858 15.355 0 21.213a14.95 14.95 0 0 0 10.607 4.393 14.95 14.95 0 0 0 10.606-4.393l42.426-42.426c5.858-5.858 5.858-15.355 0-21.213s-15.356-5.858-21.213 0"
                                data-original="#000000"
                              ></path>
                            </svg>
                            <span>
                              Status
                            </span>
                          </div>
                          <div className="info-label-badge">
                            {virtualAccountView.data.virtual_account.status}
                          </div>
                        </div>
                        <div className="account-info-card">
                          <div className="info-label-card">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              id="Layer_1"
                              width="24"
                              height="24"
                              data-name="Layer 1"
                              viewBox="0 0 24 24"
                              fill="#878e96"
                            >
                              <path d="M15 6c0-3.309-2.691-6-6-6S3 2.691 3 6s2.691 6 6 6 6-2.691 6-6m-6 4c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m-.008 4.938a1 1 0 0 1-.869 1.116A7.006 7.006 0 0 0 1.999 23a1 1 0 0 1-2 0c0-4.531 3.386-8.37 7.876-8.93a1.003 1.003 0 0 1 1.116.869Zm13.704 4.195-.974-.562c.166-.497.278-1.019.278-1.572s-.111-1.075-.278-1.572l.974-.562a1 1 0 0 0-1-1.732l-.973.562A4.97 4.97 0 0 0 18 12.101V11a1 1 0 0 0-2 0v1.101a5 5 0 0 0-2.723 1.594l-.973-.562a1 1 0 0 0-1 1.732l.974.562c-.166.497-.278 1.019-.278 1.572s.111 1.075.278 1.572l-.974.562a1 1 0 0 0 1 1.732l.973-.562A4.97 4.97 0 0 0 16 21.897v1.101a1 1 0 0 0 2 0v-1.101a5 5 0 0 0 2.723-1.594l.973.562a.997.997 0 0 0 1.366-.366 1 1 0 0 0-.366-1.366M17 19.999c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3"></path>
                            </svg>
                            <span>
                              BIC
                            </span>
                          </div>
                          <div className="info-label-data">
                            {virtualAccountView.data.virtual_account.bank_code}
                            <CopyToClipboard
                              onCopy={() => getSuccessNotificationMessage("Copied")}
                              text={virtualAccountView.data.virtual_account.bank_code}
                            >
                              <Button className="copy-token-btn">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlSpace="preserve"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="#298bff"
                                    d="M18.375 6.25h-8.75A3.044 3.044 0 0 0 6.25 9.625v8.75a3.044 3.044 0 0 0 3.375 3.375h8.75a3.044 3.044 0 0 0 3.375-3.375v-8.75a3.044 3.044 0 0 0-3.375-3.375m1.875 12.125c0 1.332-.543 1.875-1.875 1.875h-8.75c-1.332 0-1.875-.543-1.875-1.875v-8.75c0-1.332.543-1.875 1.875-1.875h8.75c1.332 0 1.875.543 1.875 1.875zM3.75 5.62v8.76c0 1.2.483 1.493.642 1.59a.751.751 0 0 1-.784 1.28 3.1 3.1 0 0 1-1.358-2.87V5.62a3.068 3.068 0 0 1 3.37-3.37h8.76a3.1 3.1 0 0 1 2.87 1.358.75.75 0 1 1-1.279.784c-.1-.159-.393-.642-1.591-.642H5.62c-1.328 0-1.87.542-1.87 1.87"
                                    data-original="#000000"
                                  ></path>
                                </svg>
                              </Button>
                            </CopyToClipboard>
                          </div>
                        </div>
                        {/* <div className="account-info-card">
                <div className="info-label-card">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Layer_1"
                    width="24"
                    height="24"
                    data-name="Layer 1"
                    viewBox="0 0 24 24"
                    fill="#878e96"
                  >
                    <path d="M16 0H8C5.243 0 3 2.243 3 5v14c0 2.757 2.243 5 5 5h8c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H8c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h8c1.654 0 3 1.346 3 3zM17 6a1 1 0 0 1-1 1H8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1m0 5a1 1 0 0 1-1 1H8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1m-4 5a1 1 0 0 1-1 1H8a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1"></path>
                  </svg>
                  <span>
                    BIC
                  </span>
                </div>
                <div className="info-label-data">
                  LU61344MQXV4662U1W1H
                  <CopyToClipboard>
                    <Button className="copy-token-btn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlSpace="preserve"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#298bff"
                          d="M18.375 6.25h-8.75A3.044 3.044 0 0 0 6.25 9.625v8.75a3.044 3.044 0 0 0 3.375 3.375h8.75a3.044 3.044 0 0 0 3.375-3.375v-8.75a3.044 3.044 0 0 0-3.375-3.375m1.875 12.125c0 1.332-.543 1.875-1.875 1.875h-8.75c-1.332 0-1.875-.543-1.875-1.875v-8.75c0-1.332.543-1.875 1.875-1.875h8.75c1.332 0 1.875.543 1.875 1.875zM3.75 5.62v8.76c0 1.2.483 1.493.642 1.59a.751.751 0 0 1-.784 1.28 3.1 3.1 0 0 1-1.358-2.87V5.62a3.068 3.068 0 0 1 3.37-3.37h8.76a3.1 3.1 0 0 1 2.87 1.358.75.75 0 1 1-1.279.784c-.1-.159-.393-.642-1.591-.642H5.62c-1.328 0-1.87.542-1.87 1.87"
                          data-original="#000000"
                        ></path>
                      </svg>
                    </Button>
                  </CopyToClipboard>
                </div>
              </div> */}
                      </div>
                      <div className="account-details-bottom">
                        <div className="account-info-card">
                          <div className="info-label-point">
                            <span>
                              Bank Name
                            </span>
                          </div>
                          <div className="info-label-info">

                            {virtualAccountView.data.virtual_account.account_bank_name}
                          </div>
                        </div>

                        <div className="account-info-card">
                          <div className="info-label-point">
                            <span>
                              Country
                            </span>
                          </div>
                          <div className="info-label-info">
                            {virtualAccountView.data.virtual_account?.external_data?.country ? iso.whereAlpha2(virtualAccountView.data.virtual_account?.external_data?.country)?.country : "N/A"}
                          </div>
                        </div>
                        <div className="account-info-vertical ">
                          <div className="info-label-point mb-2">
                            <span>
                              Address
                            </span>
                          </div>
                          <div className="info-label-info">
                            {virtualAccountView.data.virtual_account.account_bank_address}
                          </div>
                        </div>
                        {/* <div className="account-info-card">
                <div className="info-label-point">
                  <span>
                    Postal Code
                  </span>
                </div>
                <div className="info-label-info">
                  0954632
                </div>
              </div> */}

                      </div>

                    </div> : <NoDataFound />
                  }
                </>
              }
            </>
          }
        </Modal.Body>

      </Modal>
    </>
  )
}

export default AccountDetailsModal;